import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { TWO_STEP_EVENT } from "@/lib/twoStep";

/** Whichever request hears TWO_STEP_REQUIRED: to the code screen, then back here. */
export function TwoStepGate() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const on = () => {
      if (location.pathname.startsWith("/mfa-challenge")) return;
      const here = `${location.pathname}${location.search}`;
      navigate(`/mfa-challenge?redirect=${encodeURIComponent(here)}`, { replace: true });
    };
    window.addEventListener(TWO_STEP_EVENT, on);
    return () => window.removeEventListener(TWO_STEP_EVENT, on);
  }, [navigate, location]);
  return null;
}
